import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;

export default class InsuranceCompanyService {
  constructor(client) {
    this.client = client;
  }

  async findAll({ employeeId, companyIds, page, size }) {
    const response = await this.client.get(
      `${apiPrefix}${v2}/insurance-companies`,
      {
        params: {
          employeeId,
          companyIds,
          page,
          size
        }
      }
    );
    return response.data;
  }
}
